import BaseBackdropLoader from '@components/common/atoms/BaseBackdropLoader';
import BaseContainer from '@components/common/atoms/container/BaseContainer';
import RenderWithDelay from '@components/common/molecules/RenderWithDelay';
import OrderListViewStore from '@components/order/stores/OrderListViewStore';
import { useRootStore } from '@hooks/useRootStore';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import OrderList from '../../../order/components/order-list/OrderList';

interface MyOrdersListPageProps {
}

const MyOrdersListPage: React.FC<MyOrdersListPageProps> = observer(({ }) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const params = useParams();

    const rootStore = useRootStore();
    const orderListViewStore = useMemo(() => new OrderListViewStore(rootStore), []);

    const { isLoading, initializeFilterAndFind } = orderListViewStore;

    useEffect(() => {
        initializeFilterAndFind(searchParams, setSearchParams, params);
    }, [])

    return (
        <BaseContainer maxWidth='md' usePaperWrapper>
            {isLoading && <RenderWithDelay>
                <BaseBackdropLoader isLoading={isLoading} />
            </RenderWithDelay>
            }
            <Typography variant='h5' mb={2}>Moje narudžbe</Typography>
            <OrderList orderListViewStore={orderListViewStore} />
        </BaseContainer>
    )
})

export default MyOrdersListPage;